module.exports = __webpack_public_path__ + "icofont.4abc402d95b5c1510848.woff";


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/assets/icon/icofont/fonts/icofont.woff?v=1.0.0-beta
// module id = ../../../../../src/assets/icon/icofont/fonts/icofont.woff?v=1.0.0-beta
// module chunks = styles